import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import { emailValidatorVerify } from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(emailValidatorVerify.type, send, socket);
}
